import { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import adminFetch from '../../services/adminFetch';
import './StreamAdminPage.css';

const STATUS_LABELS = {
  completed: '已完成',
  completed_with_errors: '已完成（有错误）',
  creating: '创建中',
  planning: '规划中',
  generating_basic: '生成基础内容',
  active: '进行中',
  pending_selection: '待选择',
  failed: '失败',
  cancelled: '已取消',
};

export default function AdminStreamListPage() {
  const [streams, setStreams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await adminFetch('/admin/streams');
      if (!res.ok) throw new Error('加载失败');
      const data = await res.json();
      setStreams(Array.isArray(data.streams) ? data.streams : []);
    } catch (e) {
      setError(e.message || '加载失败');
      setStreams([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  if (loading) {
    return (
      <div className="admin-page">
        <div className="admin-loading">加载空间列表…</div>
      </div>
    );
  }

  return (
    <div className="admin-page">
      <header className="admin-header">
        <h1>全部互动空间</h1>
        <button type="button" className="admin-refresh-btn" onClick={load}>刷新</button>
      </header>

      {error && (
        <div className="admin-error" style={{ margin: '1rem' }}>
          {error}
        </div>
      )}

      <div className="admin-body" style={{ padding: '0 1rem 2rem' }}>
        <table className="admin-stream-list-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>名称</th>
              <th>创建状态</th>
              <th>访客可见</th>
              <th>活跃</th>
              <th>排序</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {streams.map((s) => (
              <tr key={s.id}>
                <td>{s.id}</td>
                <td>{s.name}</td>
                <td title={s.creation_status}>
                  {STATUS_LABELS[s.creation_status] || s.creation_status}
                </td>
                <td>{s.is_public ? '是' : '否'}</td>
                <td>{s.is_active ? '是' : '否'}</td>
                <td>{s.display_order}</td>
                <td>
                  <Link to={`/admin/stream/${s.id}`} className="btn-sm btn-primary">管理</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {streams.length === 0 && !error && <p style={{ marginTop: '1rem', color: '#888' }}>暂无直播间</p>}
      </div>
    </div>
  );
}
